<template>
  <view-experimental-data-component
    ref="viewExperimentalDataComponent"
    :currentExperimentalData="currentExperimentalData" 
    :restructuredExperimentalData="restructuredExperimentalData" 
    :headerArray="headerArray" 
    :analytesIdArray="analytesIdArray" 
    :seriesArray="seriesArray" 
    :experimentalDataRows="experimentalDataRows" 
    :assessmentMethod="assessmentMethod" 
    :experimentalDataset="experimentalDataset" 
    :experimentalDataImage="experimentalDataImage" 
    @editCell="handleEditCell" :analyteShortNameArray="analyteShortNameArray"
    @showResult="handleShowResult"
    @computeResult="handleComputeResult" :currentAnalyte="currentAnalyte"
    @requiresValidation="handleRequiresValidation"
    :analyteObjectArray="analyteObjectArray"
    @saveExpectedConcentration="handleSaveExpectedConcentration"
    :analyteLoadStatus="analyteLoadStatus"
    @saveAlfaBetaK="handleSaveAlfaBetaK"
    :userInputData="userInputData">
  </view-experimental-data-component>
</template>

<script>
import ViewExperimentalDataComponent from '@/components/dataset/ViewExperimentalDataComponent'
import axios from "axios"
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: "ViewExperimentalData",
  components: {ViewExperimentalDataComponent},

  data: function () {
    return {
      component_url: 'experiments/datasets/',
      assessmentMethod:{},
      experimentalDataset:{},
      currentExperimentalData: {},
      currentExperimentalDataObj: {},
      restructuredExperimentalData: [],
      headerSet: new Set(),
      experimentalDataRows:[],
      experimentalDataImage:[],
      headerArray:[],
      seriesArray:[],
      analytesIdArray:[],
      analyteShortNameArray:[],
      currentAnalyte:'',
      needsValidation:false,
      analyteObjectArray:[],
      analyteLoadStatus:'',
      // whether or not user has provided and save all required input data
      userInputProvided: false,
      userInputData:[]
    }
  },

  computed: {
    ...mapGetters ([
      'base_url', 'currentExperimentalDataObject', 'auth_header', 'columnHeaders'
    ])
  },

  mounted: function() {
    this.setBreadcrumb();

    if (this.$route.params.obj) {
      this.currentExperimentalDataObj = this.$route.params.obj;     
      if(this.$route.params.obj.from == 'upload-experimental-dataset-component'){
          this.handleRequiresValidation()
      } 
    }
    else if(this.currentExperimentalDataObject) {
      console.log("OpenExperimentalData view no router params.obj")
      this.currentExperimentalDataObj = this.currentExperimentalDataObject
    } else {
      this.loading = false;
      this.$toast.open({
          duration: 5000,
          message: `No Data to show`,
          position: 'is-top',
          type: 'is-danger'
      })
      this.$router.push({ name: "ViewAnExperimentalDataset", params: {} });
    }        
           
    //set ExperimentalData id in vuex
    this.setExperimentalDataObject()        
    this.getAssesmentMethod()
        
  },
  beforeRouteLeave (to, from, next) {
      if(this.needsValidation == true){
          if(this.assessmentMethod.name.includes('CCα and CCβ') && this.userInputProvided==false) {
              this.$toast.open({
                  message: `Provide data for Alfa, Beta and K before you continue.`,
                  position: 'is-top',
                  type: 'is-danger'
              }) 
          }
          else if(this.assessmentMethod.name.includes('CCα and CCβ') && this.userInputProvided==true) {
            next();
          }
          else if(!this.assessmentMethod.name.includes('CCα and CCβ')){
              this.$dialog.confirm({
                  title: 'Validate Data',
                  message: 'Changes were made on the data. Validate data before exiting page.',
                  onConfirm: () => {
                      this.handleComputeResult()
                      this.$toast.open({
                          message: `Data validation started`,
                          position: 'is-top',
                          type: 'is-primary'
                      }) 
                      next();
                  },
                  onCancel: () => {
                      next(false);
                  }
              }) 
          }                
      } else {
          next();
      }
  },
  methods: {
      ...mapMutations([
          'SET_BREADCRUMB', 'CHANGE_EXPERIMENTAL_DATA_OBJECT', 'CHANGE_OVERVIEW_OBJECT', 'CHANGE_ASSESSMENT_METHOD_OBJECT'
      ]),
      setBreadcrumb: function(){
          this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
      },
      //set global ExperimentalDataobject
      setExperimentalDataObject: function(){
          this.CHANGE_EXPERIMENTAL_DATA_OBJECT(this.currentExperimentalDataObj)
      },
      handleSaveAlfaBetaK: function(alfaBetaKObject){
        //   var analyte = this.analyteObjectArray.find(item => item.short_name.toUpperCase() == alfaBetaKObject.analyte)
        var dataValue = this.currentExperimentalData['1']
        var requestData = []
        var index = 0
        this.analyteObjectArray.forEach((analyte) =>{
            index = index - 1;
            var temp = [
                {
                    experiment_data: {"name": "alfa", "data_type": "float", "type": 0},
                    value: alfaBetaKObject.alfa,
                    series: null,
                    level: null,
                    parallel: null,
                    marker: null,
                    row: index,
                    analyte: analyte.id,
                    experiment_dataset: dataValue.experiment_dataset,
                    assessment_method: dataValue.assessment_method
                },
                {
                    experiment_data: {"name": "beta", "data_type": "float", "type": 0},
                    value: alfaBetaKObject.beta,
                    series: null,
                    level: null,
                    parallel: null,
                    marker: null,
                    row: index,
                    analyte: analyte.id,
                    experiment_dataset: dataValue.experiment_dataset,
                    assessment_method: dataValue.assessment_method
                },
                {
                    experiment_data: {"name": "K", "data_type": "float", "type": 0},
                    value: alfaBetaKObject.k,
                    series: null,
                    level: null,
                    parallel: null,
                    marker: null,
                    row: index,
                    analyte: analyte.id,
                    experiment_dataset: dataValue.experiment_dataset,
                    assessment_method: dataValue.assessment_method
                }
            ]
            requestData = requestData.concat(temp)
        })
        axios
            .post(
                  this.base_url+ 'experiments/data-value/', requestData,
                  { 
                      headers: this.auth_header
                  }
            )
            .then(response => {                  
                  this.$toast.open({
                      message: `Alfa, Beta and K has been saved successfully!`,
                      position: 'is-top',
                      type: 'is-primary'
                  })
                  this.userInputProvided = true
                  console.log("alfa res", response)
            })
            .catch(error => {                   
                  console.log("Alfa, Beta and K was not successfully saved", error.response.data);
                  this.$toast.open({
                      message: `Saving Alfa, Beta and K unsuccessfully!`,
                      position: 'is-top',
                      type: 'is-danger'
                  })
            });            
      },
      handleRequiresValidation: function(){
          this.needsValidation = true
      },
      getAssesmentMethod: function(){
          axios
              .get(
                  this.base_url+ "experiments/assessments/"  + this.currentExperimentalDataObj.assesment_method_id,
                  {
                      headers: this.auth_header
                  }
              )
              .then(response => {
                  this.assessmentMethod = response.data   
                  console.log("this.assessmentMethod ", this.assessmentMethod )
                  this.getExperimentalDataset()
              })
              .catch(error => {
                  console.log("Something went wrong getting the current ass meth", error);
              });
      },
      getExperimentalDataset: function(){
          axios
              .get(
                  this.base_url+ 'experiments/datasets/' +
                  this.currentExperimentalDataObj.experimental_dataset_id,
                  {
                      headers: this.auth_header
                  }
              )
              .then(response => {
                  this.experimentalDataset = response.data;  
                  this.getExperimentalData()                     
              }) 
              .catch(error => {
                  console.log("Something went wrong getting the current Experimental Dataset", error);
              });
      },
      getExperimentalData: function(){
          axios
              .get(
                  this.base_url+ this.component_url + this.currentExperimentalDataObj.experimental_dataset_id + '/assessments/' + this.currentExperimentalDataObj.assesment_method_id + '/input/',
                  {
                      headers: this.auth_header
                  }
              )
              .then(response => {
                  this.currentExperimentalData = response.data

                  console.log("raw data..",  this.currentExperimentalData)

                  //check if there is Data
                  if(Object.keys(response.data).length==0){
                      this.loading = false;
                      this.$toast.open({
                          duration: 5000,
                          message: `No Data to show! Upload dataset`,
                          position: 'is-top',
                          type: 'is-danger'
                      })
                      this.$router.push({ name: "ViewAnExperimentalDataset", params: {} });
                  } 
                  else {
                      //check if its an image or dataset
                      if(this.assessmentMethod.name.toUpperCase().includes('UPLOAD')) {
                          this.getDataImage()
                      } else {
                          this.restructuredExperimentalData = []
                          this.restructureExperimentalData()
                      }
                  }

                  
              })
              .catch(error => {
                  console.log("Something went wrong getting the currentExperimentalData", error);
              });
      },
      setOverviewObject: function(){
          // if a dataset is updated this will clear the cached overview object
          this.CHANGE_OVERVIEW_OBJECT({})
      },
      setAssessmentMethodObject: function() {
          this.CHANGE_ASSESSMENT_METHOD_OBJECT({})
      },
      handleSaveExpectedConcentration: function(dataCell){
          console.log("handleSaveExpectedConcentration", dataCell)
          axios
              .post(
                  this.base_url+ 'experiments/data-value/', dataCell,
                  { 
                      headers: this.auth_header
                  }
              )
              .then((response) => {                  
                  this.$toast.open({
                      message: `${response.data.experiment_data.name} has been saved successfully!`,
                      position: 'is-top',
                      type: 'is-primary'
                  })
                //   this.getExperimentalData()
              })
              .catch(error => {                   
                  console.log("Expected Concentration not successfully saved", error.response.data);
                  this.$toast.open({
                      message: `Saving unsuccessfully!`,
                      position: 'is-top',
                      type: 'is-danger'
                  })
              });
      },
      handleEditCell: function(dataCell) {
          console.log("Data cell ", dataCell)
          axios
              .patch(
                  this.base_url+ 'experiments/data-value/' + dataCell.id, dataCell,
                  { 
                      headers: this.auth_header
                  }
              )
              .then((response) => {                  
                  console.log("Data cell ", dataCell.id, "updated successfully!", response.data);
                  this.getExperimentalData()
                  // clear overview data from store
                  this.setOverviewObject()
                  this.setAssessmentMethodObject()
              })
              .catch(error => {                   
                  console.log("Data cell not successfully updated", error);
              });            
      },
      handleComputeResult: function() {
          this.$toast.open({
              message: `Calculations of results started successfully. Continue to the Overview section to view results!`,
              position: 'is-top',
              type: 'is-info'
          })
          axios
              .post(
                  `${this.base_url}${this.component_url}${this.experimentalDataset.id}/assessments/${this.assessmentMethod.id}/output/`,
                  { 
                      headers: this.auth_header
                  }
              )
              .then(() => {                  
                  this.$toast.open({
                      message: `Calculation of results successful!`,
                      position: 'is-top',
                      type: 'is-success'
                  });
                  this.$refs.viewExperimentalDataComponent.isCalculated = true;
                  console.log("Math module started successfully!");
              })
              .catch(error => {                   
                  console.log("Math module not started successfully updated", error.response.data);
                                    
                  this.$toast.open({
                      message: `Calculation of results unsuccessful! ${error.response.data}`,
                      position: 'is-top',
                      type: 'is-danger'
                  })
              });    
              this.needsValidation = false        
      },
      handleShowResult: function() {
        this.$router.push({ name: "DatasetOverview", params: {datasetId: this.experimentalDataset.id } });
      },
      getDataImage: function(){
          this.experimentalDataImage=[]
          this.analyteShortNameArray=[]
          this.analyteObjectArray=[]

          console.log('check...', this.currentExperimentalData[0])
          var mainThis = this
          this.analyteShortNameArray.push('NONE')
          this.currentAnalyte = 'NONE'
          var setOfAnalytes = new Set()
          this.currentExperimentalData[0].chromatogram.forEach(function (experimentalData, index) {
              experimentalData['index']=index+1
              mainThis.experimentalDataImage.push(experimentalData)
              mainThis.needsValidation = false   

              if(experimentalData.analyte!=null){
                  setOfAnalytes.add(experimentalData.analyte)
              }
          })

          this.analytesIdArray = Array.from(setOfAnalytes)
          delete this.currentExperimentalData[0]
          this.userInputData = Object.entries(this.currentExperimentalData).map(item=>item[1])
          this.analytesIdArray.forEach(function(analyteId) {
              mainThis.getAnalyte(analyteId)
          })
          console.log("this.experimentalDataImage", this.experimentalDataImage)
          console.log("this.userInputData", this.userInputData)
      },
      getAnalyte: function(analyteId){
          axios
              .get(
                  this.base_url+ 'experiments/analytes/' + analyteId,
                  {
                      headers: this.auth_header
                  }
              )
              .then(response => {
                  // adds analyte short name to an array and assigns a value to the current analyte
                  this.analyteShortNameArray.push(response.data.short_name.toUpperCase());
                  this.currentAnalyte = response.data  
                  this.analyteObjectArray.push(response.data)
                  this.experimentalDataImage.forEach(function(rowData) {
                      if(rowData.analyte == analyteId){
                          rowData.analyte = response.data
                          rowData.analyte.key = "analyte"
                          rowData.analyte.value = response.data.short_name
                      }
                  })
                  if(this.analyteShortNameArray.length==this.analytesIdArray.length){
                      this.analyteLoadStatus = 'Loaded'
                  }
              })
              .catch(error => {
                  console.log("Something went wrong getting an analyte", error);
              });
      },
    restructureExperimentalData: function() {
      this.restructuredExperimentalData = []
      this.analyteShortNameArray = [] 
      var setOfSeries = new Set()
      var setOfHeaders = new Set()
      var setOfAnalytes = new Set()
      const keys_to_ignore = ['experiment_dataset', 'rounded_value', 'analyte', 'series', 'assessment_method', 'row', 'marker']
      // foreach row
      var currentExperimentalData = Object.entries(this.currentExperimentalData).map(x => x[1]).filter(item=>item.row>0)
      this.userInputData = Object.entries(this.currentExperimentalData).map(x => x[1]).filter(item=>item.row<0)

      let allAnalyteIds = []
      currentExperimentalData.forEach( dataRow => {
        let analyteId = dataRow.analyte;
        allAnalyteIds.push(analyteId);
      })
      allAnalyteIds = new Set(allAnalyteIds);

      let allAnalytes = {};

      allAnalyteIds.forEach( analyteId => {
          axios.get(
              this.base_url + 'experiments/analytes/' + analyteId,
              {
               headers: this.auth_header
              }
          )
          .then(response => {
            allAnalytes[analyteId] = response.data;

            for(let analyteId of allAnalyteIds){
              if(!allAnalytes[analyteId]){
                return;
              }
            }

            afterHaveAllAnalytes();
          });
      });

      var that = this;
      currentExperimentalData.forEach( dataRow => {
        Object.entries(dataRow).forEach(cell => {
          // get all the available series and analytes
          if (cell[0] == 'series' && cell[1] != null) {
            setOfSeries.add(cell[1])
          }
          if (cell[0] == 'analyte' && cell[1] != null) {
            setOfAnalytes.add(cell[1])
          }
          // populate table header values
          if (!keys_to_ignore.includes(cell[0])) {
            setOfHeaders.add(cell[0])
          }
        });

        that.seriesArray = Array.from(setOfSeries);
        that.analytesIdArray = Array.from(setOfAnalytes)
      });

      function afterHaveAllAnalytes(){
        currentExperimentalData.forEach( dataRow => {
            // change analyte id to analyte object
            var analyteId = dataRow.analyte
            let analyte = allAnalytes[analyteId];
            dataRow.analyte = analyte
            that.restructuredExperimentalData.push(dataRow)
            if(!that.analyteShortNameArray.includes(analyte.short_name.toUpperCase())){
              that.analyteShortNameArray.push(analyte.short_name.toUpperCase())
            }
            if(!that.analyteObjectArray.find(element => element.id == analyte.id)){
              that.analyteObjectArray.push(analyte)
            }
            if(that.currentAnalyte == ''){
              that.currentAnalyte = analyte.short_name
            }
            // change analyte id to analyte object
        })
      }

      // sort table header array
      this.headerArray = Array.from(setOfHeaders)
      this.headerArray.sort((a, b) => {
        return this.columnHeaders.indexOf(a.toLowerCase()) - this.columnHeaders.indexOf(b.toLowerCase())
      })
      console.log("restructuredExperimentalData", this.restructuredExperimentalData)
    }
  }

}
</script>
